export default "__VITE_ASSET__CLSiVyO$__"